const eventClickBannerCoupon = (params, category) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: `promotionClick`,
      eventCategory: `ecommerce promotion`,
      eventLabel: category,
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: `${params?.id || 'not available'}`,
              name: `${params?.title?.toLowerCase() || 'not available'}`,
              creative: `${params.link?.toLowerCase() || 'not available'}`,
              position: `1 - ${params.typeService} servis`,
            },
          ],
        },
      },
    });
  }
};
export default eventClickBannerCoupon;
